export default "__VITE_ASSET__8q58NOpJ__"